import { addLanguageToPath, isChinaDomainClient } from "@Utils/languageCore";

interface ICustomWindowLocationParams {
  url: string;
  isExternal?: boolean;
  replace?: boolean;
}

/**
 * Utility function for window.location navigation with language routing
 * Use this in non-React contexts (e.g., Redux thunks, utility functions)
 * For React components, use the useCustomWindowLocation hook instead
 *
 * @param url - The URL to navigate to
 * @param isExternal - If true, navigates to URL as-is without language prefix
 * @param replace - If true, uses location.replace instead of location.href (no history entry)
 */
export const customWindowLocation = ({
  url,
  isExternal = false,
  replace = false,
}: ICustomWindowLocationParams): void => {
  if (!url) return;

  // Get user language from window.__INITIAL_STATE__ (same pattern as customHistoryPush)
  const { appData }: any = window.__INITIAL_STATE__;
  const userLanguage = appData?.userLanguage || "en";

  // Check if this is China domain - skip language prefix for China
  const isChinaDomain = isChinaDomainClient();

  // For China domain, never add language prefix (Chinese is default)
  // Use URL as-is for external links or for China domain
  const shouldAddLanguagePrefix = !isExternal && !isChinaDomain;
  const finalUrl = shouldAddLanguagePrefix ? addLanguageToPath(url, userLanguage) : url;

  if (replace) {
    window.location.replace(finalUrl);
  } else {
    window.location.href = finalUrl;
  }
};

export default customWindowLocation;
